(function () {
  // ------------- tiny utils
  var d = document;
  // The rebuilt full cart owns its form's validation. Other pages retain
  // their existing drawer behavior, without installing a second cart guard.
  if (d.querySelector('[data-gw-full-cart]')) return;
  function $(sel, root){ return (root||d).querySelector(sel); }
  function $all(sel, root){ return Array.from((root||d).querySelectorAll(sel)); }
  function txt(el){ return (el && (el.innerText || el.textContent) || '').trim().toLowerCase(); }

  // ------------- checkbox + error
  function getCB(){ return $('#AjaxCartTerms') || $('#CartTerms'); }
  function getErr(){ return $('#AjaxCartTermsError') || $('#CartTermsError'); }
  function isAgreed(){ var cb = getCB(); return !!(cb && cb.checked); }
  function showError(){ var e=getErr(), cb=getCB(); if(e) e.style.display=''; if(cb) cb.focus(); }
  function hideError(){ var e=getErr(); if(e) e.style.display='none'; }

  // ------------- stamp attributes on the cart form
  function stampAttributes(form){
    if (!form) return;
    var acc = form.querySelector('input[name="attributes[Accepted Terms]"]');
    if (!acc){ acc = d.createElement('input'); acc.type='hidden'; acc.name='attributes[Accepted Terms]'; form.appendChild(acc); }
    acc.value = 'yes';

    var ts = form.querySelector('input[name="attributes[Terms accepted at]"]');
    if (!ts){ ts = d.createElement('input'); ts.type='hidden'; ts.name='attributes[Terms accepted at]'; form.appendChild(ts); }
    ts.value = new Date().toISOString();
  }

  // ------------- identify ANY checkout control
  function looksLikeCheckout(el){
    if (!el || el.nodeType !== 1) return false;
    // obvious signals
    var href = (el.getAttribute('href') || '').toLowerCase();
    var name = (el.getAttribute('name') || '').toLowerCase();
    var id   = (el.getAttribute('id')   || '').toLowerCase();
    var cls  = (el.getAttribute('class')|| '').toLowerCase();

    if (href.includes('/checkout')) return true;
    if (name === 'checkout' || id === 'checkout') return true;
    if (cls.includes('checkout') || cls.includes('cart__checkout') || el.hasAttribute('data-checkout-button') || el.hasAttribute('data-continue-to-checkout')) return true;

    // fallback: text says "checkout"
    if (txt(el) === 'checkout' || txt(el).includes('checkout')) return true;

    return false;
  }

  // ------------- disable/enhance UI state
  function setCheckoutDisabled(disabled){
    // grab lots of candidates
    var candidates = $all([
      'a', 'button', 'input[type="submit"]',
      'form[action^="/cart"] a',
      'form[action^="/cart"] button',
      'form[action^="/cart"] input[type="submit"]'
    ].join(','));
    candidates.forEach(function(el){
      if (!looksLikeCheckout(el)) return;
      // Visual & semantic
      if (el.tagName === 'BUTTON' || el.tagName === 'INPUT') {
        el.toggleAttribute('disabled', disabled);
        el.setAttribute('aria-disabled', String(disabled));
      }
      el.classList.toggle('is-disabled', disabled);
    });
  }

  // ------------- main guards
  function attachGuards(){
    // A) Block any submit to /cart or /checkout
    d.addEventListener('submit', function(e){
      var form = e.target;
      var rawAction = (form.getAttribute('action') || '').toLowerCase();
var actionPath;

try {
  actionPath = new URL(rawAction, window.location.origin).pathname.toLowerCase();
} catch (_) {
  actionPath = rawAction;
}

// Only guard actual cart/checkout submits.
// Do NOT block add-to-cart forms like /cart/add.
var isAddToCart = actionPath.includes('/cart/add');
var leadsToCheckout =
  !isAddToCart &&
  (
    actionPath === '/cart' ||
    actionPath.endsWith('/cart') ||
    actionPath.includes('/checkout')
  );

if (!leadsToCheckout) return;

      if (!isAgreed()){
        e.preventDefault(); e.stopImmediatePropagation(); showError();
      } else {
        stampAttributes(form);
      }
    }, true); // capture

    // B) Block clicks on anything that looks like a checkout control
    d.addEventListener('click', function(e){
      var el = e.target.closest && e.target.closest('a,button,input[type="submit"]');
      if (!looksLikeCheckout(el)) return;

      if (!isAgreed()){
        e.preventDefault(); e.stopImmediatePropagation(); showError();
      } else {
        var form = el.closest && el.closest('form');
if (form) {
  var formAction = (form.getAttribute('action') || '').toLowerCase();
  if (!formAction.includes('/cart/add')) {
    stampAttributes(form);
  }
}
        if (form) stampAttributes(form);
      }
    }, true);

    // C) Block programmatic nav to /checkout
    var _ps = history.pushState, _rs = history.replaceState;
    function guardNav(fn){ return function(state,title,url){
      try { if (String(url || '').indexOf('/checkout') !== -1 && !isAgreed()) { showError(); return; } }
      catch(_){}
      return fn.apply(this, arguments);
    }; }
    history.pushState = guardNav(_ps);
    history.replaceState = guardNav(_rs);

    var _assign = window.location.assign.bind(window.location);
    window.location.assign = function(url){
      if (String(url).indexOf('/checkout') !== -1 && !isAgreed()) { showError(); return; }
      _assign(url);
    };
  }

  // ------------- handle dynamic drawers/rerenders
  function observeDrawer(){
    var drawer = d.querySelector('#CartContainer, cart-drawer, #CartDrawer');
    if (!drawer) return;
    var mo = new MutationObserver(function(){
      var cb = getCB();
      if (!cb) return;
      setCheckoutDisabled(!cb.checked);
    });
    mo.observe(drawer, { childList: true, subtree: true });
  }

  // ------------- boot
  function init(){
    var cb = getCB();
    if (cb){
      setCheckoutDisabled(!cb.checked);
      cb.checked ? hideError() : showError();
      cb.addEventListener('change', function(){
        var ok = cb.checked;
        setCheckoutDisabled(!ok);
        ok ? hideError() : showError();
      });
    }
    attachGuards();
    observeDrawer();
    // debug flag so you can verify the script loaded
    window.__cartTermsLoaded = true;
    console.log('cart-terms guard ready');
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init);
  else init();
})();
